import Loading from './component';
export default Loading;
